<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'TASKS' }]"
></breadcrumbs>

<page-header title="TASKS"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('filtered')"
  [itemsPerPage]="pagination.page_size"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  [rows]="state.get('data')"
  [currentPage]="pagination.page"
  [sort]="pagination.sort"
  [orderBy]="pagination.order_by"
  [columns]="columns"
  [showFilter]="true"
  [showReload]="true"
  (onFilterChange)="handleFilterChange($event)"
  [filters]="filters"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <button
        type="button"
        class="button is-small is-info"
        translationEditableDirective="AUTOASSIGN_TASKS"
        (click)="autoAssign()"
        [disabled]="autoAssignLoading"
      >
        {{ 'AUTOASSIGN_TASKS' | translate }}
      </button>
    </div>
  </ng-template>

  <ng-template let-row="row" let-index="index" #type>
    <span
      [translationEditableDirective]="row.getIn(['type', 'translationKey'])"
      >{{
        row.getIn(['type', 'translationKey'])
          | translate : { defaultValue: row.getIn(['type', 'title']) }
      }}</span
    >
  </ng-template>
  <ng-template let-row="row" let-index="index" #objectType>
    <span
      [translationEditableDirective]="
        row.getIn(['objectType', 'translationKey'])
      "
      >{{
        row.getIn(['objectType', 'translationKey'])
          | translate : { defaultValue: row.getIn(['objectType', 'title']) }
      }}</span
    >
  </ng-template>
  <ng-template let-row="row" let-index="index" #code>
    <a
      [routerLink]="[
        '/',
        row.getIn(['objectType', 'name']) === 'BUSINESS'
          ? 'businesses'
          : 'properties',
        row.getIn(['objectLabelId', 'id'])
      ]"
      >{{ row.getIn(['objectLabelId', 'label']) }}</a
    >
  </ng-template>
</app-table>
